import { Component, OnInit } from '@angular/core';
import {APIHelper} from "../../apihelper";
import {SharedResources} from "../../shared-resources";

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  currentScreen: string = '';
  constructor() {
    SharedResources._currentScreenBS.subscribe((data: any) => {
      this.currentScreen = data;
    });
  }

  ngOnInit(): void {
    this.currentScreen = 'orders';
  }


}
